export default __webpack_public_path__ + "static/media/smallPlayer.7270c692.png";